import type { ActivityLog } from '../../types';

export const getStatusBadgeColor = (status: ActivityLog['level']) => {
  switch (status) {
    case 'Info':
      return 'success';
    case 'Problem':
      return 'danger';
    default:
      return 'secondary';
  }
};

export const formatInitiator = (actorType: ActivityLog['actorType'], userName?: string | null) => {
  switch (actorType) {
    case 'Customer':
      return 'Customer';
    case 'System':
      return 'System';
    case 'Client Service':
      return userName ? `Client Service (${userName})` : 'Client Service';
    default:
      return actorType || '-';
  }
};
